
  import React, { useEffect, useState, useMemo } from "react";
  import { useDispatch } from "react-redux";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { FaCartPlus } from "@react-icons/all-files/fa/FaCartPlus";
  import { getWishlistProducts } from "../../../../redux/reduxApi/website/WishlistApi";
  import { cartProductCount } from "../../../../redux/reduxApi/website/CartProductCount";
  import toast from "react-hot-toast";
import {FaArrowRightLong} from "react-icons/fa6";
  import {
    addToWishlist,
    deleteFromWishlist,
  } from "../../../../redux/api/website/AddtoWishlistApi";
  import { getWishlistCount } from "../../../../redux/reduxApi/website/WishlistApi";
  import { useNavigate, useLocation } from "react-router-dom";
  import { AddToCart } from "../../shop/utilsfuncart";
  import { CiStar } from "react-icons/ci";
  import Shoploader from "../../loader/Shoploader";
  import { BsCartCheckFill } from "react-icons/bs";
import { useSelector } from "react-redux";
  export default function Wishlist() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const url = useLocation();
    const [likedProducts, setLikedProducts] = useState([]);
    const wishlistData = useSelector(
      (state) => state.Wishlist.WishListProducts.wishlist
    );
    const wishlistItems = useMemo(() => {
      return Array.isArray(wishlistData) ? wishlistData : [];
    }, [wishlistData]);
    const productData = useMemo(() => {
      return wishlistItems.map((item) => ({
        ...item,
        part_key: item.partKey,
        part_no: item.partNo,
        part_type: item.partType,
        sellingPrice: parseFloat(item.price) || 0,
        aaiabrandid: item.aaiabrandid || "",
        image: item.image || "",
      }));
    }, [wishlistItems]);
    const [loading, setLoading] = useState(true);
    const [addedToCartItems, setAddedToCartItems] = useState(new Set());

    useEffect(() => {
      const fetchWishlist = async () => {
        setLoading(true);
        try {
          await dispatch(getWishlistProducts());
        } finally {
          setLoading(false);
        }
      };
      fetchWishlist();
    }, [dispatch]);

    useEffect(() => {
      setLikedProducts(wishlistItems.map((item) => item.partKey));
    }, [wishlistItems]);

    // 🔁 UPDATED: Accept full product object
    const toggleLike = async (product) => {
      if (!localStorage.getItem("customerId")) {
        localStorage.setItem("redirect", url.pathname);
        navigate("/login");
        return;
      }

      const partKey = product.part_key;
      setLikedProducts((prev) =>
        prev.includes(partKey)
          ? prev.filter((id) => id !== partKey)
          : [...prev, partKey]
      );

      if (!likedProducts.includes(partKey)) {
        await addToWishList(product);
      } else {
        await deleteFromWishList(product);
      }
    };

    // 🔁 UPDATED: Send price and other details
    const addToWishList = async (product) => {
      const wishlistdata = {
        customerId: localStorage.getItem("customerId"),
        partKey: product.part_key,
        uniqueSerialNo: product.part_no + product.aaiabrandid,
        price: product.sellingPrice ?? 0,
        part_no: product.part_no,
        brand: product.brand || "",
        supplier: product.supplier || "",
        part_type: product.part_type || "",
        image: product.image || "",
      };
      try {
        const response = await dispatch(addToWishlist(wishlistdata));
        if (response.payload.data.success) {
          dispatch(getWishlistCount());
          toast.success("Product added to wishlist successfully");
        }
      } catch (error) {
        console.error("Error adding product to wishlist:", error);
      }
    };

    // 🔁 UPDATED: Accept full product
    const deleteFromWishList = async (product) => {
      const payload = {
        customerId: localStorage.getItem("customerId"),
        partkey: product.part_key,
      };
      try {
        const response = await dispatch(deleteFromWishlist(payload));
        if (response.payload.data.success) {
          dispatch(getWishlistCount());
          dispatch(getWishlistProducts());
          toast.success("Product removed from wishlist successfully");
          setLikedProducts((prev) =>
            prev.filter((id) => id !== product.part_key)
          );
        }
      } catch (error) {
        console.error("Error removing product from wishlist:", error);
      }
    };

    const handleNavigateSinglePage = (item) => {
      navigate(`/shop/single-product/${item.part_key}`, {
        state: {
          uniqueKey: item.part_no + (item.aaiabrandid || ""),
          part_no: item.part_no,
          sellingPrice: item?.sellingPrice || 0,
          // prefetchedPartDetail: item,
        },
      });
    };

    return (
      <>
        <div className="w-full h-full lg:py-[10px] md:py-[20px]">
          <h1 className="text-center w-full text-blue-900 font-bold md:mt-[15px] lg:mt-0 mt-[-13px] lg:text-[40px] md:text-4xl text-3xl lg:mb-2">
            Wishlist
          </h1>
          <hr className="heading-seperator border-4 border-blue-900" />

          {loading ? (
            <div className="relative w-full flex items-center justify-center h-[300px]">
              <Shoploader />
            </div>
          ) : productData && productData.length > 0 ? (
            <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-3 w-full">
              {productData.map((item, idx) => (
                <div
                  className="relative border-2 w-full shadow-md rounded-lg
                  hover:border-blue-400 hover:scale-[102%] transition-all duration-300 
                  ease-in-out overflow-hidden flex flex-col bg-white"
                  key={item.part_key ?? idx}
                >
                  {/* Header with tags & heart */}
                  <div className="flex justify-between w-full items-start">
                    <div className="flex space-x-1">
                      {item.tags?.map((tag) => (
                        <span
                          key={tag}
                          className={`text-xs font-bold px-2 py-1 rounded ${
                            tag === "Sale"
                              ? "bg-yellow-500 text-white"
                              : tag === "Popular"
                              ? "bg-blue-900 text-white"
                              : "bg-green-500 text-white"
                          }`}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <FaHeart
                      size="25px"
                      className={`absolute top-2.5 right-2.5 group-hover:opacity-100 transition-opacity duration-300 z-1 cursor-pointer ${
                        likedProducts?.includes(item.part_key)
                          ? "text-orange-500"
                          : "text-black"
                      }`}
                      onClick={() =>
                        likedProducts?.includes(item.part_key)
                          ? deleteFromWishList(item)
                          : toggleLike(item)
                      }
                    />
                  </div>

                  {/* Image */}
                  {item?.image ? (
                    <img
                      src={item.image}
                      alt={item.part_key}
                      onClick={() => handleNavigateSinglePage(item)}
                      className="w-full h-[20vh] object-contain p-1 hover:scale-90 transition-all duration-300 ease-in-out cursor-pointer"
                    />
                  ) : (
                    <img
                      src="https://www.showmethepartsdb2.com/bin/images/na-showme.jpg"
                      alt={item.part_key}
                      onClick={() => handleNavigateSinglePage(item)}
                      className="w-full h-[20vh] object-contain p-1 hover:scale-90 transition-all duration-300 ease-in-out cursor-pointer"
                    />
                  )}

                  {/* Details */}
                  <div className="px-2 py-1 space-y-0.5 text-sm">
                    <p className="font-semibold text-base truncate cursor-pointer" onClick={() => handleNavigateSinglePage(item)}>
                      {item.part_type || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Supplier:</span> {item.supplier || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Location:</span> {item.location || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Brand:</span> {item.brand || "N/A"}
                    </p>
                    <p>
                      <span className="font-medium">Part Number:</span> {item.part_no || "N/A"}
                    </p>
                  </div>

                  {/* Price & Rating */}
                  <div className="flex items-center justify-between mx-2 mt-1">
                    <div className="text-red-600 font-bold">
                      {typeof item?.sellingPrice === "number"
                        ? `$${item.sellingPrice.toFixed(2)}`
                        : "Loading..."}
                    </div>
                    <div className="flex space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <CiStar key={i} className="text-gray-400" />
                      ))}
                    </div>
                  </div>

                  {/* Add To Cart Button */}
                  <div className="flex justify-start items-end h-full m-2 mt-1">
                    <button
                      onClick={async () => {
                        await AddToCart({
                          ...item,
                          uniqueKey: item.part_no + (item.aaiabrandid || ""),
                        });
                        setAddedToCartItems(
                          (prev) => new Set([...prev, item.part_key])
                        );
                        dispatch(
                          cartProductCount(localStorage.getItem("customerId"))
                        );
                      }}
                      className={`text-white ${
                        addedToCartItems.has(item.part_key)
                          ? "bg-green-500"
                          : "bg-blue-900"
                      } lg:p-2 md:px-[0.2rem] md:py-[0.5rem] p-[0.65rem] w-full rounded-lg font-bold flex items-center justify-center text-sm hover:scale-90 transition-all duration-300 ease-in-out`}
                    >
                      {addedToCartItems.has(item.part_key) ? (
                        <>
                          <BsCartCheckFill size="19px" className="me-2" />
                          Added to Cart
                        </>
                      ) : (
                        <>
                          <FaCartPlus size="19px" className="me-2" />
                          Add To Cart
                        </>
                      )}
                      <FaArrowRightLong size="17px" className="mx-2" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-500">No products in wishlist.</p>
          )}
        </div>
      </>
    );
  } 